import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, ShieldCheckIcon, GiftIcon, XIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const [showGuarantee, setShowGuarantee] = useState(false);
  const handleBuyClick = () => {
    trackAddToCart();
    window.open('https://dailyhomewellness.com/cart/48013338214644:1', '_blank', 'noopener,noreferrer');
  };
  const checklistItems = ['Las 100 preguntas oficiales del USCIS', 'Simulación completa de entrevista N-400', 'Guía rápida de preguntas difíciles', 'Resumen visual de temas clave', 'Mini plantilla de autoprueba semanal', 'Frases clave en inglés'];
  return <section id="offer-section" className="w-full bg-white py-10 lg:py-24" data-id="element-163">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-2 border-[#C9A84C] rounded-2xl shadow-2xl overflow-hidden" data-id="element-165">
          {/* Top Banner */}
          <div className="bg-[#C9A84C] text-[#1B2A4A] text-center py-3 font-bold text-sm sm:text-base tracking-widest uppercase" data-id="element-166">
            Oferta Especial
          </div>

          <div className="p-6 sm:p-10" data-id="element-167">
            {/* Title & Subtitle */}
            <div className="text-center mb-10" data-id="element-168">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-3" data-id="element-169">
                Ciudadanía USA Guía Exprés 2026
              </h2>
              <p className="text-gray-600 text-lg" data-id="element-170">
                El único sistema bilingüe diseñado específicamente para
                hispanohablantes
              </p>
            </div>

            {/* Two Columns */}
            <div className="grid md:grid-cols-2 gap-8 lg:gap-12 mb-10" data-id="element-171">
              {/* Left Column */}
              <div className="space-y-6" data-id="element-172">
                <div className="bg-[#F7F5F0] rounded-xl p-6" data-id="element-173">
                  <h3 className="font-bold text-[#1B2A4A] text-lg mb-4" data-id="element-174">
                    Estás comprando:
                  </h3>
                  <ul className="space-y-3" data-id="element-175">
                    {checklistItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-176">
                        <CheckCircleIcon className="w-5 h-5 text-[#C9A84C] flex-shrink-0 mt-0.5" data-id="element-177" />
                        <span className="text-gray-700 text-sm sm:text-base" data-id="element-178">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <div className="bg-[#FFFDF8] border border-[#C9A84C]/30 rounded-xl p-6" data-id="element-179">
                  <h3 className="font-bold text-[#1B2A4A] text-md mb-4 flex items-center gap-2" data-id="element-180">
                    <GiftIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-181" />+ 2 Bonos
                    GRATIS <span className="text-[#C9A84C]" data-id="element-182">(Valor $44)</span>
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-183">
                    <div className="text-center" data-id="element-184">
                      <img src="https://cdn.magicpatterns.com/uploads/onq38wYPTYXiX3pJk62UM9/Portada_bonus_1.png" alt="Banco Bilingüe" className="w-full rounded shadow-md mb-2 object-cover" data-id="element-185" />
                      <p className="text-xs font-semibold text-[#1B2A4A]" data-id="element-186">
                        Banco Bilingüe
                      </p>
                    </div>
                    <div className="text-center" data-id="element-187">
                      <img src="https://cdn.magicpatterns.com/uploads/rS4VnxqiHeP3H4nvLrcXZ1/Portada_bonus_2.png" alt="Audio de Práctica" className="w-full rounded shadow-md mb-2 object-cover" data-id="element-188" />
                      <p className="text-xs font-semibold text-[#1B2A4A]" data-id="element-189">
                        Audio de Práctica
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column (Clickable) */}
              <div onClick={handleBuyClick} className="cursor-pointer flex flex-col items-center justify-center bg-white rounded-xl p-6 sm:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow h-full" data-id="element-190">
                <div className="flex items-center gap-3 mb-2" data-id="element-191">
                  <span className="text-gray-400 line-through text-xl font-medium" data-id="element-192">
                    $91
                  </span>
                  <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded" data-id="element-193">
                    92% OFF
                  </span>
                </div>

                <div className="text-6xl sm:text-7xl font-bold text-[#1B2A4A] tracking-tight mb-2" data-id="element-194">
                  $6.99
                </div>

                <p className="text-gray-500 text-sm mb-8" data-id="element-195">
                  Pago único · Acceso inmediato
                </p>

                <div id="buy-button" className="w-full mb-4" data-id="element-196">
                  <motion.button whileHover={{
                  scale: 1.03
                }} whileTap={{
                  scale: 0.97
                }} className="w-full bg-[#C9A84C] text-[#1B2A4A] px-6 py-4 rounded-lg font-semibold text-base tracking-[0.12em] uppercase shadow-lg hover:bg-[#d4b35c] transition-all duration-300" data-id="element-197">
                    <span className="flex flex-col items-center gap-0.5 leading-snug" data-id="element-198">
                      <span data-id="element-199">Quiero el Sistema</span>
                      <span className="text-[#1B2A4A]/50 text-xs" data-id="element-200">+</span>
                      <span data-id="element-201">Bonos Ahora</span>
                    </span>
                  </motion.button>
                </div>

                <p className="text-gray-500 text-xs text-center mb-6" data-id="element-202">
                  Descarga inmediata · Solo necesitas tu celular
                </p>

                <div className="w-full bg-gray-50 rounded-lg p-3 flex items-center justify-center gap-2" data-id="element-203">
                  <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-204" />
                  <span className="text-sm text-gray-700 font-medium" data-id="element-205">
                    Garantía de satisfacción de 30 días
                  </span>
                </div>
              </div>
            </div>

            {/* Summary Table */}
            <div className="border-t border-gray-200 pt-8" data-id="element-206">
              <div className="max-w-md mx-auto space-y-3 text-sm sm:text-base" data-id="element-207">
                <div className="flex justify-between text-gray-600" data-id="element-208">
                  <span data-id="element-209">Ciudadanía USA Guía Exprés 2026</span>
                  <span data-id="element-210">$47</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-211">
                  <span data-id="element-212">2 Bonos GRATIS</span>
                  <span data-id="element-213">$44</span>
                </div>
                <div className="flex justify-between font-bold text-[#1B2A4A] pt-3 border-t border-gray-100" data-id="element-214">
                  <span data-id="element-215">Valor Total</span>
                  <span className="line-through" data-id="element-216">$91</span>
                </div>
                <div className="flex justify-between font-bold text-lg pt-2 text-[#C9A84C]" data-id="element-217">
                  <span data-id="element-218">Hoy pagas solo</span>
                  <span data-id="element-219">$6.99</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Urgency Text */}
        <div className="text-center mt-10 space-y-2" data-id="element-220">
          <p className="text-lg font-bold text-red-600" data-id="element-221">
            Tu entrevista no espera. Tu ciudadanía tampoco.
          </p>
          <p className="text-gray-600" data-id="element-222">
            Cada día que pasa sin prepararte es un día más de ansiedad
            innecesaria.
          </p>
          <p className="text-[#1B2A4A] font-bold mt-4" data-id="element-223">
            El sistema está listo. Solo falta que tú decidas usarlo.
          </p>
        </div>
      </div>
      {showGuarantee && <AnimatePresence data-id="element-224">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={() => setShowGuarantee(false)} data-id="element-225">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-226">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#1B2A4A]" data-id="element-227">
                <h2 className="text-xl font-bold text-white font-serif" data-id="element-228">
                  Garantía de Satisfacción
                </h2>
                <button onClick={() => setShowGuarantee(false)} className="text-gray-300 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-229">
                  <XIcon className="w-6 h-6" data-id="element-230" />
                </button>
              </div>
              <div className="px-6 py-8 text-center" data-id="element-231">
                <ShieldCheckIcon className="w-16 h-16 text-[#C9A84C] mx-auto mb-6" data-id="element-232" />
                <h3 className="text-2xl font-bold text-[#1B2A4A] mb-4" data-id="element-233">
                  Tu Garantía Total de 30 Días
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-234">
                  El riesgo lo corremos nosotros. Si demuestras implementación y
                  no estás conforme con el producto, tienes un plazo de 30 días
                  para solicitar reembolso. Sin preguntas y sin complicaciones,
                  te devolvemos tu dinero.
                </p>
                <p className="text-xl font-bold text-[#C9A84C]" data-id="element-235">
                  No tienes nada que perder. Y una ciudadanía que ganar.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>}
    </section>;
}